import { render, staticRenderFns } from "./BdTicket.vue?vue&type=template&id=0210de8c&scoped=true&"
import script from "./BdTicket.vue?vue&type=script&lang=js&"
export * from "./BdTicket.vue?vue&type=script&lang=js&"
import style0 from "./BdTicket.vue?vue&type=style&index=0&id=0210de8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210de8c",
  null
  
)

export default component.exports